export default {
  getSuggestions: (state) => state.suggestions.list.items,
  getSuggestionsPaginationData: (state) => state.suggestions.list.meta,
  getSuggestionsIsFetching: (state) => state.suggestions.list.isFetching,
};
